/**
 * Client-side failure reporting through the telemetry Pulse already uses
 * (PostHog snippet in public/index.html). No new vendor. Best effort:
 * reporting must never throw or block the UI.
 */
export function reportClientError(kind, details = {}) {
  try {
    const payload = {
      kind,
      path: window.location?.pathname,
      ...details,
    };
    if (window.posthog?.capture) window.posthog.capture("pulse_client_error", payload);
    // eslint-disable-next-line no-console
    console.error(`[pulse:${kind}]`, payload);
  } catch {
    /* never let telemetry break the app */
  }
}

let installed = false;

/** Global safety net for unhandled promise rejections and errors. */
export function installGlobalErrorHandlers() {
  if (installed || typeof window === "undefined") return;
  installed = true;
  window.addEventListener("unhandledrejection", (event) => {
    const r = event.reason;
    // A cancelled request is an intentional outcome (route change), not
    // an error — swallow it so it never surfaces as a crash overlay.
    if (r?.code === "ERR_CANCELED" || r?.name === "CanceledError") {
      event.preventDefault();
      return;
    }
    reportClientError("unhandled_rejection", {
      message: String(r?.message || r).slice(0, 300),
      status: r?.response?.status,
      url: r?.config?.url,
    });
  });
  window.addEventListener("error", (event) => {
    reportClientError("window_error", {
      message: String(event.message || "").slice(0, 300),
    });
  });
}
